import { Stack } from "@certa/catalyst/layouts/Stack";
import { useIntl } from "react-intl";
import {
  Typography,
  TypographyVariants
} from "@certa/catalyst/components/Typography";
import { Checkbox, CheckboxGroup } from "@certa/catalyst/components/Checkbox";
import { TextInput } from "@certa/catalyst/components/Inputs/Text";
import { Search } from "@certa/icons/components/Search";
import { useMemo, useState } from "react";
import { Box } from "@certa/catalyst/layouts/Box";
import { Spinner } from "@certa/icons/components/Spinner";
import { AnalyticsEvents, analyticsService } from "@certa/analytics";

type FilterDropdownProps = {
  label: string;
  options: { label: string; value: string }[];
  selectedValues: string[];
  onChange: (value: string[]) => void;
  areOptionsLoading: boolean;
  statusType: string;
};

const FilterDropdown = (props: FilterDropdownProps) => {
  const {
    label,
    options,
    selectedValues,
    onChange,
    areOptionsLoading,
    statusType
  } = props;

  const intl = useIntl();

  const [searchValue, setSearchValue] = useState("");

  const noOptionsFound = intl.formatMessage({
    id: "list.options.empty",
    defaultMessage: "No options"
  });

  const filteredData = useMemo(
    () =>
      options.filter(
        item =>
          item.label.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1
      ),
    [options, searchValue]
  );

  const handleTrackAnalytics = (value: string, checked: boolean) => {
    analyticsService.track(
      AnalyticsEvents.globalSearchEvents.GLOBAL_SEARCH_CATEGORY_SELECT,
      {
        value: value,
        checked,
        certa_version: "OS3",
        type: label,
        status_type: statusType
      }
    );
  };

  return (
    <>
      <Stack direction="vertical" gap="12" width="15.875rem">
        <Box padding="8 8 0 8">
          <TextInput
            label={label}
            placeholder={`Search By ${label}...`}
            value={searchValue}
            leftIcon={<Search color="neutral-70" />}
            onChange={setSearchValue}
            allowClear
            onClear={() => setSearchValue("")}
            width="100%"
          />
        </Box>
        <Stack height="16rem" gap="12" padding="0 0 0 4">
          {filteredData.length > 0 ? (
            <>
              <Box overflow="auto">
                <CheckboxGroup
                  name={`select-filter-${label}`}
                  value={selectedValues}
                  onChange={onChange}
                  direction="vertical"
                >
                  {filteredData.map(item => (
                    <Checkbox
                      checked={selectedValues.includes(item.value)}
                      key={item.value}
                      value={String(item.value)}
                      label={item.label}
                      onChange={checked => {
                        handleTrackAnalytics(item.label, checked);
                      }}
                    />
                  ))}
                </CheckboxGroup>
              </Box>
            </>
          ) : (
            <Stack
              height="100%"
              direction="horizontal"
              justify="center"
              align="center"
            >
              {areOptionsLoading ? (
                <Spinner />
              ) : (
                <Typography variant={TypographyVariants.BODY}>
                  {noOptionsFound}
                </Typography>
              )}
            </Stack>
          )}
        </Stack>
      </Stack>
    </>
  );
};
export { FilterDropdown };
